import type { EmailBindingFormValues } from './model/schema';
import type { EmailBindingTarget, ProfileEmailBindingRequest } from './model/types';

/** Преобразует форму привязки почты в запрос выбранного профиля */
export const emailBindingFormToRequest = (
    target: EmailBindingTarget,
    values: EmailBindingFormValues,
): ProfileEmailBindingRequest => target.kind === 'client'
        ? {
            kind: 'client',
            request: {
                clientId: target.profileId,
                email: values.email.trim(),
            },
        }
        : {
            kind: 'executor',
            request: {
                executorId: target.profileId,
                email: values.email.trim(),
            },
        };
